/* ==========================================================================
   Shop behaviour — filters and quick add. Vanilla, no dependencies.

   DELIBERATE BOUNDARY
   This file never touches Craft's cart drawer, cart notification, or
   product-form custom elements. It posts to /cart/add.js, refreshes the
   header count through Shopify's Section Rendering API, and shows its own
   inline confirmation. If this script fails to load, every Add to cart button
   is still a real form POST that works without JavaScript.

   FILTERS
   Client-side show/hide over products already present in the HTML, so the
   markup stays crawlable and filtering costs no page load. For very large
   collections this should move to Shopify's native faceted filtering — noted
   in the section file.
   ========================================================================== */

(function () {
  'use strict';

  /* --- Filters ---------------------------------------------------------- */
  function initFilters(root) {
    var shop = (root || document).querySelector('[data-lk-shop]');
    if (!shop) return;

    var chips = shop.querySelectorAll('[data-lk-chip]');
    var cards = shop.querySelectorAll('[data-lk-card]');
    var countEl = shop.querySelector('[data-lk-count]');
    var emptyEl = shop.querySelector('[data-lk-empty]');
    if (!chips.length || !cards.length) return;

    var active = { type: '', tag: '' };

    function matches(card) {
      var typeOk = !active.type || card.dataset.lkType === active.type;
      var tagOk =
        !active.tag ||
        (card.dataset.lkTags || '').split('|').indexOf(active.tag) !== -1;
      return typeOk && tagOk;
    }

    function apply() {
      var shown = 0;
      cards.forEach(function (card) {
        var visible = matches(card);
        card.hidden = !visible;
        if (visible) shown++;
      });

      if (countEl) {
        countEl.textContent =
          shown === cards.length
            ? cards.length + ' products'
            : shown + ' of ' + cards.length + ' products';
      }
      if (emptyEl) emptyEl.hidden = shown !== 0;
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var group = chip.dataset.lkGroup; // "type" or "tag"
        var value = chip.dataset.lkChip;
        var isOn = chip.getAttribute('aria-pressed') === 'true';

        // Radio behaviour inside a group, and clicking the active chip clears it.
        shop
          .querySelectorAll('[data-lk-group="' + group + '"]')
          .forEach(function (other) {
            other.setAttribute('aria-pressed', 'false');
          });

        if (isOn) {
          active[group] = '';
        } else {
          active[group] = value;
          chip.setAttribute('aria-pressed', 'true');
        }
        apply();
      });
    });

    apply();
  }

  /* --- Quick add -------------------------------------------------------- */
  function updateCartCount() {
    // Ask Shopify to re-render just the header's cart bubble.
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + '?sections=cart-icon-bubble')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data['cart-icon-bubble']) return;
        var target = document.getElementById('cart-icon-bubble');
        if (!target) return;
        var parsed = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html');
        var fresh = parsed.querySelector('.shopify-section');
        if (fresh) target.innerHTML = fresh.innerHTML;
      })
      .catch(function () {
        /* The item is in the cart either way; a stale bubble is not worth an error. */
      });
  }

  function initQuickAdd(root) {
    var forms = (root || document).querySelectorAll('[data-lk-add]');

    forms.forEach(function (form) {
      if (form.dataset.lkBound === 'true') return;
      form.dataset.lkBound = 'true';

      form.addEventListener('submit', function (event) {
        if (!window.fetch) return; // let the plain POST happen

        event.preventDefault();

        var button = form.querySelector('button[type="submit"]');
        var card = form.closest('[data-lk-card]');
        var panel = card && card.querySelector('[data-lk-added-panel]');
        var original = button ? button.textContent : '';

        if (button) {
          button.disabled = true;
          button.textContent = button.dataset.lkLabelAdding || 'Adding…';
        }

        fetch(window.routes && window.routes.cart_add_url ? window.routes.cart_add_url + '.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              {
                id: Number(form.querySelector('[name="id"]').value),
                quantity: 1
              }
            ]
          })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('add failed');
            return response.json();
          })
          .then(function () {
            if (panel) {
              panel.hidden = false;
              // Announced politely so a screen reader hears the result
              // without losing the user's place on the page.
              panel.setAttribute('role', 'status');
            }
            if (button) {
              button.textContent = button.dataset.lkLabelAdded || 'Added to cart';
              button.disabled = false;
            }
            updateCartCount();
          })
          .catch(function () {
            // Fall back to the real form POST rather than stranding the user.
            if (button) {
              button.disabled = false;
              button.textContent = original;
            }
            form.submit();
          });
      });
    });
  }

  function init(root) {
    initFilters(root);
    initQuickAdd(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
